var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "add_post_dialog",
      attrs: {
        modal: true,
        "modal-append-to-body": true,
        title: _vm.title,
        visible: _vm.show,
        "close-on-click-modal": false,
        "show-close": true,
        "close-on-press-escape": true,
        "before-close": _vm.clickCancel,
        width: "600px"
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "newPostForm",
          staticClass: "newPostForm",
          attrs: { model: _vm.newPostForm, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "postName", label: "岗位名称" } },
            [
              _c("el-input", {
                attrs: {
                  autocomplete: "off",
                  placeholder: "请输入岗位名称",
                  maxlength: "20"
                },
                model: {
                  value: _vm.newPostForm.postName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.newPostForm,
                      "postName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "newPostForm.postName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "postCode", label: "岗位编码" } },
            [
              _c("el-input", {
                attrs: {
                  autocomplete: "off",
                  placeholder: "请输入岗位编码",
                  maxlength: "20"
                },
                model: {
                  value: _vm.newPostForm.postCode,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.newPostForm,
                      "postCode",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "newPostForm.postCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.clickCancel } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitForm("newPostForm")
                }
              }
            },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be0913a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be0913a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/educationalAdmin/educationalAdminMenu/subjectDialog/addPostDialog.vue
// module id = null
// module chunks = 